import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { ServiceTypesRedux } from '../Redux/ServiceTypesRedux'

const serviceTypesCrudObservable = createCRUDObservable({
  mainRedux: ServiceTypesRedux,
  reduxPath: 'service_types',
  dataHandlers: {
    get: response => response.data.data,
  },
})

export const serviceTypesObservers = Object.assign({}, serviceTypesCrudObservable.observers, {})

export const serviceTypesEpic = combineEpics(
  serviceTypesCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ServiceTypesObservable.js